import { CSSProperties, PropsWithChildren, useCallback, useEffect, useRef, useState } from 'react';
import './Banner.scss';

interface IBannerProps {
  show: boolean;
  color?: 'red' | 'green' | 'blue';
  onClose?: () => void;
}

export default function Banner({ show, color = 'red', children, onClose }: PropsWithChildren<IBannerProps>) {
  const [visible, setVisible] = useState(false);
  const [bannerHeight, setBannerHeight] = useState(0);
  const bannerRef = useRef<HTMLDivElement>(null);
  const hideBanner = useCallback(() => setVisible(false), []);
  useEffect(() => {
    if (bannerRef.current) {
      const height = bannerRef.current.offsetHeight;
      setBannerHeight(height);
    }
    if (!show) {
      hideBanner();
      return;
    }
    setVisible(true);
  }, [hideBanner, show, setBannerHeight]);
  const containerStyle: CSSProperties = {
    visibility: visible ? 'visible' : 'hidden',
    maxHeight: visible ? `${bannerHeight}px` : '0px',
  };
  const bannerStyle: CSSProperties = {
    transform: visible ? 'translateY(0)' : 'translateY(-100%)',
  };
  const closeBannerHandler = useCallback(() => {
    hideBanner();
    onClose && onClose();
  }, [hideBanner, onClose]);
  return (
    <div className="banner-container" style={containerStyle}>
      <div className={`banner ${color}`} style={bannerStyle} ref={bannerRef}>
        <div className="banner-main">{children}</div>
        <span className="banner-close" onClick={closeBannerHandler}>
          X
        </span>
      </div>
    </div>
  );
}
